export const isValidMeetingUrl = (urlString: string): boolean => {
  if (!urlString || urlString.trim() === "") {
    return false;
  }

  try {
    const parsedUrl = new URL(urlString.trim());
    const protocol = parsedUrl.protocol.toLowerCase();

    if (protocol !== "https:") {
      return false;
    }

    if (!parsedUrl.hostname || !parsedUrl.hostname.includes(".")) {
      return false;
    }

    if (
      parsedUrl.hostname === "localhost" ||
      parsedUrl.hostname.startsWith("127.") ||
      parsedUrl.hostname.startsWith("192.168.") ||
      parsedUrl.hostname.startsWith("10.") ||
      parsedUrl.hostname === "0.0.0.0"
    ) {
      return false;
    }

    return true;
  } catch {
    return false;
  }
};

export const getMeetingUrlError = (
  urlString: string,
  touched: boolean,
): string => {
  const trimmedUrl = urlString.trim();

  if (!touched && !trimmedUrl) {
    return "";
  }

  if (!trimmedUrl) {
    return "Meeting link is required.";
  }

  if (!isValidMeetingUrl(trimmedUrl)) {
    return "Enter a valid HTTPS link.";
  }

  return "";
};
